import Slider from "react-rangeslider";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { CircularProgressBar } from "@tomik23/react-circular-progress-bar";
import "react-rangeslider/lib/index.css";

import {
  DeleteStakingRiskProductsUserInfoThunk,
  UpdateStakingRiskProductUserInfoThunk,
} from "../../Thunks/StakingRiskThunk";
import { renderClassName, resolveRiskValue } from "./utils/stakingRiskHelpers";
import chart_open from "../../Assets/img/icons/chart__icon__open.svg";
import double_arrow from "../../Assets/img/icons/double-arrow.png";
import { ApiPutStakingRiskProductUserInfo } from "../../Api";
import chart from "../../Assets/img/icons/chart__icon.svg";
import { formatStakingCurrency } from "../../Utils/helper";
import { DeleteCardModule } from "../../Modal/DeleteCard";
import { ChartModal } from "../../Modal/Chart";
import { NoAlertComponent } from "../NoAlert";
import styles from "./stakingRisk.module.css";

export function StakingRiskCardExisting({ element, id }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [stakedAmountInput, setStakedAmountInput] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openUnstaking, setOpenUnstaking] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [openChart, setOpenChart] = useState(false);
  const [alertvalue, setAlertValue] = useState();

  const safetyIndex = resolveRiskValue(element?.stakingRisk?.safetyIndex);
  const riskColor =
    safetyIndex >= 65
      ? "green"
      : safetyIndex >= 31
        ? "yellow"
        : safetyIndex > 0
          ? "red"
          : "white";
  const cardConfig = renderClassName(safetyIndex, riskColor, 112);

  useEffect(() => {
    setAlertValue(+element.alert);
  }, [element]);

  const handleChange = (value) => {
    setAlertValue(value);
  };

  const alertOnChangeComplete = (valu) => {
    ApiPutStakingRiskProductUserInfo(element.id, +alertvalue)
      .then((result) => {})
      .catch((error) => {});
  };
  useEffect(() => {
    if (element?.stakedAmount) {
      setStakedAmountInput(`${formatStakingCurrency(element?.stakedAmount)}`);
    } else {
      setStakedAmountInput("");
    }
  }, [element?.stakedAmount]);

  const handleStackedChange = (e) => {
    const rawValue = e.target.value;
    const numericOnly = rawValue.replace(/[^\d]/g, "");
    setStakedAmountInput(formatStakingCurrency(rawValue));

    if (numericOnly !== "") {
      dispatch(
        UpdateStakingRiskProductUserInfoThunk(id, "", parseInt(numericOnly)),
      );
    }
  };

  const handleBlur = () => {
    const numericOnly = stakedAmountInput.replace(/[^\d]/g, ",");
    setStakedAmountInput(formatStakingCurrency(numericOnly));
  };

  const zoomActive = localStorage.getItem("zoomActive") === "true";

  return (
    <>
      <div
        className={`${cardConfig.className} ${styles.stakingRisk}`}
        onClick={() => {
          navigate(`/staking-risk/details/${id}`, {
            state: { productId: id, selectedProduct: null },
          });
        }}
      >
        <div className="card__header">
          <div className="row">
            <div
              className="chart__open__btn"
              onClick={(e) => {
                e.stopPropagation();
                setOpenChart(!openChart);
              }}
            >
              {openChart ? (
                <img src={chart} alt="" className="chart__opened__btn__icon" />
              ) : (
                <img
                  src={chart_open}
                  alt=""
                  className="chart__open__btn__icon"
                />
              )}
            </div>
            <h2 className="card__title" style={{ cursor: "pointer" }}>
              {element.stakingRisk.name}
            </h2>
            <div
              className="close__card__content"
              onClick={(e) => {
                e.stopPropagation();
                setOpenDeleteModal(!openDeleteModal);
              }}
            >
              <span className="card__close">
                <span></span>
                <span></span>
              </span>
            </div>
          </div>
        </div>
        <div
          className="card__price"
          style={{
            justifyContent: zoomActive ? "space-between" : "space-around",
          }}
        >
          <div
            style={{ marginLeft: "20px", position: "relative" }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <input
              type="text"
              className="card__wallet__input"
              value={stakedAmountInput}
              onChange={(e) => {
                e.stopPropagation();
                handleStackedChange(e);
              }}
              onBlur={(e) => {
                e.stopPropagation();
                handleBlur(e);
              }}
              onFocus={(e) => {
                e.stopPropagation();
              }}
              style={{
                marginTop: "5px",
                padding: "0px 0px 0 15px",
                borderRadius: "6px",
                border: "navajowhite",
                width: zoomActive ? "230px" : "100%",
                background: "transparent",
                outline: "none",
                color: "#364048",
                fontWeight: "bold",
                textAlign: "right",
                fontSize: "13px",
                fontFamily: "Assistant",
              }}
            />
            <span
              style={{
                position: "absolute",
                padding: "0px 0px",
                top: "50%",
                left: zoomActive ? "-10px" : "-20px",
                transform: "translateY(-50%)",
                color: "#889096",
                fontSize: "13px",
                fontWeight: "600",
                pointerEvents: "none",
                fontFamily: "Assistant",
              }}
            >
              Staked
            </span>
          </div>
        </div>

        <div
          className="card__product__wrapper"
          style={{ paddingTop: "5px", position: "relative" }}
        >
          <div>
            <div
              className={` ${styles.staking_card_product_scroller} 
              ${isExpanded ? styles.expanded : ""}`}
              style={{ height: zoomActive && isExpanded ? "325px" : null }}
            >
              {element.stakingRisk?.stakingRiskClassifications.map(
                (item, index) => {
                  const level =
                    item.riskScoreType === "manual"
                      ? item.manualScoreLevel
                      : item.automaticScoreLevel;

                  const classificationColor = level?.includes("Low")
                    ? "#4DC7B5"
                    : level?.includes("Medium") && !level?.includes("High")
                      ? "#EFB661"
                      : level?.includes("High")
                        ? "#F27281"
                        : "#C4C4C4";

                  return (
                    <div
                      key={index}
                      className="card_product_scroller_item"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        padding: "8px 0",
                        borderBottom: "1px solid #e0e0e0",
                      }}
                    >
                      <p
                        className={styles.staking_card_product_title}
                        title={item.name}
                      >
                        {item.name.length > 15
                          ? item.name.slice(0, 15) + "…"
                          : item.name}
                      </p>

                      <p
                        className={styles.staking_card_product_level}
                        style={{ color: classificationColor }}
                      >
                        {level?.replace("Risk", "").trim()}
                      </p>
                    </div>
                  );
                },
              )}
            </div>
            <div
              className={`${styles.double_arrow} ${
                isExpanded ? styles.rotate : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsExpanded(!isExpanded);
              }}
            >
              <img src={double_arrow} alt="Toggle" />
            </div>
          </div>
        </div>
        <div
          className="card__risk"
          style={{
            marginTop: "5px",
            position: "absolute",
            left: "0",
            right: "15px",
            top: zoomActive ? "220px" : "175px",
            zIndex: isExpanded && zoomActive ? "-1" : null,
          }}
        >
          <h3 className="card__risk__title">Safety Index</h3>
          <div
            className={
              "card__risk__alert" +
              " " +
              (openProgress ? "active" : "card__risk__alert")
            }
            onClick={(event) => {
              event.stopPropagation();
              setOpenProgress(!openProgress);
              setOpenUnstaking(false);
            }}
          >
            <p className="card__risk__alert__title">Alert</p>
            <p
              className={
                "card__risk__alert__number" +
                " " +
                (alertvalue === 0 || null
                  ? "card__risk__alert__not_number"
                  : "card__risk__alert__number")
              }
            >
              {alertvalue === null || 0 ? 0 : alertvalue}
            </p>
          </div>
          {openProgress ? (
            <div
              className={
                "card__risk__range active card__slider" +
                " " +
                (alertvalue === 0 || null
                  ? "card__slider_not_value"
                  : "card__risk__range active card__slider")
              }
              onClick={(e) => e.stopPropagation()}
              style={{ padding: 10 }}
            >
              <Slider
                min={0}
                max={100}
                value={alertvalue === null || 0 ? 0 : alertvalue}
                orientation="vertical"
                onChange={handleChange}
                tooltip={true}
                onChangeComplete={alertOnChangeComplete}
                step={1}
                className="tooltip"
              />
            </div>
          ) : (
            ""
          )}
          <div className="card__risk__chart" style={{ marginTop: "5px" }}>
            <CircularProgressBar {...cardConfig.props}>
              <div className="card__round__shadow"></div>
              <div className="card__risk__chart__min__wrapper">
                <p
                  className="card__risk__chart__number"
                  style={{
                    color: cardConfig.props.fontColor,
                  }}
                >
                  {Math.round(safetyIndex)}
                </p>
              </div>
            </CircularProgressBar>
          </div>
          <div
            className="card__risk__info"
            onClick={(e) => {
              e.stopPropagation();
              setTimeout(() => {
                setShowAlert(true);
              });
              setTimeout(() => {
                setShowAlert(false);
              }, 2000);
            }}
            style={{ bottom: "-8px", left: "40px" }}
          >
            <i className="icon-info-icon"></i>
          </div>
        </div>
      </div>
      <OutsideClickHandler
        onOutsideClick={(event) => {
          setOpenChart(false);
        }}
      >
        {openChart ? (
          <ChartModal
            element={element}
            closeModal={() => {
              setOpenChart(false);
            }}
          />
        ) : (
          ""
        )}
      </OutsideClickHandler>
      <OutsideClickHandler
        onOutsideClick={(event) => {
          setOpenDeleteModal(false);
        }}
      >
        {openDeleteModal ? (
          <DeleteCardModule
            title="You are going to delete the Staking Risk Product"
            text="This Staking Risk Product will be deleted, but can be restored from the Recycle Bin."
            element={element}
            deleteItem={(id) => {
              dispatch(DeleteStakingRiskProductsUserInfoThunk(id));
            }}
            cancel={(event) => {
              setOpenDeleteModal(event);
            }}
          />
        ) : (
          ""
        )}
      </OutsideClickHandler>
      <OutsideClickHandler
        onOutsideClick={(event) => {
          setShowAlert(false);
        }}
      >
        {showAlert ? <NoAlertComponent top={60} title={"No Alerts."} /> : ""}
      </OutsideClickHandler>
    </>
  );
}
